import { render, staticRenderFns } from "./TasksList.vue?vue&type=template&id=7fda67a0&lang=pug"
import script from "./TasksList.vue?vue&type=script&lang=ts"
export * from "./TasksList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports